import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, withKeys as _withKeys, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "headerMobile"
}
const _hoisted_2 = { class: "headerMobile_col -name" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "headerMobile_col -title" }
const _hoisted_5 = {
  key: 0,
  class: "headerMobile_title"
}
const _hoisted_6 = { class: "headerMobile_col -nav" }
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = { class: "headerMobile_menu-wrapper" }
const _hoisted_9 = {
  key: 0,
  class: "headerMobile_menuBadge"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ac_points_label = _resolveComponent("ac-points-label")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_nav_bar_mobile = _resolveComponent("nav-bar-mobile")!
  const _component_search_overlay = _resolveComponent("search-overlay")!

  return (_ctx.showLayout)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["headerMobile_wrapper", {
        '-withoutPoints': !_ctx.showPoints,
        '-noBack': !_ctx.showBack
      }]),
          "data-cy": "headerMobile",
          onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onHandlerEsc && _ctx.onHandlerEsc(...args)), ["esc"])),
          tabindex: "0"
        }, [
          (_ctx.showBack)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "headerMobile_col -back",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, [...(_cache[5] || (_cache[5] = [
                _createStaticVNode("<div class=\"headerMobile_back\"><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_27173_231743)\"><path d=\"M14.7015 6.37573L9.07654 12.0007L14.7015 17.6257\" stroke=\"currentColor\" stroke-width=\"1.875\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g><defs><clipPath id=\"clip0_27173_231743\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg></div>", 1)
              ]))]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            (_ctx.avatar)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "headerMobile_avatar",
                  src: _ctx.avatar,
                  alt: _ctx.title
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              (_ctx.title)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.title), 1))
                : _createCommentVNode("", true),
              (_ctx.showPoints)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    class: "headerMobile_points",
                    to: { name: 'points' }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ac_points_label, {
                        class: "-enabled",
                        points: _ctx.userScoreAmount
                      }, null, 8, ["points"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _renderSlot(_ctx.$slots, "menu", {}, () => [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.isSearchVisible)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "headerMobile_searchTrigger",
                    "data-test": "header-search-trigger",
                    type: "button",
                    "aria-label": _ctx.$t('search.title'),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isSearchOpen = true))
                  }, [...(_cache[6] || (_cache[6] = [
                    _createStaticVNode("<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_25141_42824)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.421 10.6749C17.421 11.5613 17.2464 12.4391 16.9072 13.258C16.568 14.077 16.0708 14.8211 15.444 15.4479C14.8172 16.0747 14.073 16.5719 13.2541 16.9111C12.4352 17.2503 11.5574 17.4249 10.671 17.4249C9.78456 17.4249 8.90682 17.2503 8.08787 16.9111C7.26893 16.5719 6.52481 16.0747 5.89802 15.4479C5.27122 14.8211 4.77402 14.077 4.4348 13.258C4.09558 12.4391 3.92099 11.5613 3.92099 10.6749C3.92099 8.88468 4.63215 7.16779 5.89802 5.90192C7.16389 4.63605 8.88078 3.92489 10.671 3.92489C12.4612 3.92489 14.1781 4.63605 15.444 5.90192C16.7098 7.16779 17.421 8.88468 17.421 10.6749ZM16.191 17.7849C14.3826 19.1889 12.107 19.8509 9.82769 19.6361C7.54834 19.4214 5.43651 18.346 3.92211 16.629C2.40772 14.912 1.60461 12.6823 1.67629 10.394C1.74797 8.1057 2.68904 5.93071 4.30792 4.31182C5.9268 2.69294 8.10179 1.75187 10.3901 1.6802C12.6784 1.60852 14.9081 2.41163 16.6251 3.92602C18.3421 5.44041 19.4174 7.55224 19.6322 9.83159C19.8469 12.1109 19.185 14.3865 17.781 16.1949L21.966 20.3799C22.0765 20.4829 22.1652 20.6071 22.2267 20.7451C22.2881 20.8831 22.3212 21.0321 22.3239 21.1831C22.3265 21.3342 22.2988 21.4842 22.2422 21.6243C22.1856 21.7644 22.1014 21.8916 21.9945 21.9984C21.8877 22.1053 21.7605 22.1895 21.6204 22.2461C21.4803 22.3027 21.3303 22.3304 21.1792 22.3278C21.0281 22.3251 20.8792 22.2921 20.7412 22.2306C20.6032 22.1691 20.479 22.0804 20.376 21.9699L16.191 17.7849Z\" fill=\"currentColor\"></path></g><defs><clipPath id=\"clip0_25141_42824\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>", 1)
                  ]))], 8, _hoisted_7))
                : _createCommentVNode("", true),
              (_ctx.nav)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args))),
                    class: "headerMobile_menu"
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _cache[7] || (_cache[7] = _createStaticVNode("<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_3976_44)\"><path d=\"M3 5C3 4.44772 3.44772 4 4 4H20C20.5523 4 21 4.44772 21 5C21 5.55228 20.5523 6 20 6H4C3.44772 6 3 5.55228 3 5ZM3 12C3 11.4477 3.44772 11 4 11H14C14.5523 11 15 11.4477 15 12C15 12.5523 14.5523 13 14 13H4C3.44772 13 3 12.5523 3 12ZM3 19C3 18.4477 3.44772 18 4 18H20C20.5523 18 21 18.4477 21 19C21 19.5523 20.5523 20 20 20H4C3.44772 20 3 19.5523 3 19Z\" fill=\"currentColor\"></path></g><defs><clipPath id=\"clip0_3976_44\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>", 1)),
                      (_ctx.isShowMenuBange)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 34),
        _createVNode(_component_nav_bar_mobile, {
          "model-value": _ctx.showMenu,
          "onUpdate:modelValue": _ctx.onNavBarClose
        }, null, 8, ["model-value", "onUpdate:modelValue"]),
        (_ctx.isSearchVisible)
          ? (_openBlock(), _createBlock(_component_search_overlay, {
              key: 0,
              modelValue: _ctx.isSearchOpen,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isSearchOpen) = $event)),
              onSubmit: _ctx.onSearchSubmit
            }, null, 8, ["modelValue", "onSubmit"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}